<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <h3 class="title is-5">Gracias por contactarse con nosotros, pronto te escribiremos.</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "Confirmation",
  mounted() {
    this.$emit('done', {
      key: 'confirmation'
    });
  }
}
</script>

<style scoped>

</style>
